const caseButtonContainer = document.querySelector('[data-behaviour="case-study-load-more-show"]');
const caseButton = document.querySelector('[data-behaviour="case-study-load-more"]');

if (caseButtonContainer) {
	caseButtonContainer.style.display = "flex";
}

if (caseButton) {

	caseButton.addEventListener('click', () => {
		// Elements
		const section = caseButton.closest('[data-ref="case-study-list"]');
		const sectionInner = section.querySelector('[data-ref="case-study-inner"]');
		let activeNav = section.querySelector('[data-active="1"]');
		// Text
		const loadingSpan = '<span>.</span><span>.</span><span>.</span>'
		const loadingText = 'Loading' + loadingSpan;
		const defaultButtonText = 'Load more';
		//Disable Button
		caseButton.disabled = true;
		caseButton.innerHTML = loadingText;
		//Form Vars
		let activeKey = activeNav.dataset?.key;
		let paged = caseButton.dataset?.paged;

		fetchCaseStudies(activeKey, paged)
			.then(response => {
				if (response.status === 'success' && response.html) {
					sectionInner.innerHTML += response.html;

					if (response.data &&
						!response.data.pagination
					) {
						caseButton.classList.add('case-study-list__button--hidden');
					} else {
						caseButton.dataset.paged = Number(caseButton.dataset.paged) + 1;
						caseButton.classList.remove('case-study-list__button--hidden');
					}

				} else {
					console.log('Error during fetch response');
				}

				caseButton.disabled = false;
				caseButton.innerHTML = defaultButtonText;
			})
			.catch(error => {
				console.log('Error during fetch: ' + error);
			});
	});
}

const caseStudyNav = document.querySelectorAll('[data-behaviour="case-study-two-filter"]');

if (caseStudyNav.length) {
	// Elements
	const section = caseStudyNav[0].closest('[data-ref="case-study-list"]');
	const sectionInner = section.querySelector('[data-ref="case-study-inner"]');

	caseStudyNav.forEach(el => {
		el.addEventListener('click', () => {
			//disabled buttons
			caseStudyNav.forEach(button => {
				button.disabled = true;
			});

			//Form Els
			const activeKey = el.dataset?.key;
			const paged = 1; // will always be 1 on first click
			const activeNav = section.querySelector('[data-active="1"]');

			fetchCaseStudies(activeKey, paged)
				.then(response => {
					if (response.status === 'success' && response.html) {
						sectionInner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							caseButton.classList.add('case-study-list__button--hidden');
						} else {
							caseButton.classList.remove('case-study-list__button--hidden');
						}

						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');

						el.dataset.active = 1;
						el.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}

					//enable buttons
					caseStudyNav.forEach(button => {
						button.disabled = false;
					});
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});
		});
	});

	const selectFilter = document.querySelector('[data-select="case-filter"]');
	if (selectFilter) {
		selectFilter.addEventListener('change', (e) => {
			let activeKey = e.target.value; //category id
			const paged = 1; // will always be 1 on first click

			fetchCaseStudies(activeKey, paged)
				.then(response => {
					if (response.status === 'success' && response.html) {
						sectionInner.innerHTML = response.html;

						if (response.data &&
							!response.data.pagination
						) {
							caseButton.classList.add('blog-post-list__button--hidden');
						} else {
							caseButton.classList.remove('blog-post-list__button--hidden');
						}
						let activeNav = section.querySelector('[data-active="1"]');
						activeNav.dataset.active = 0;
						activeNav.classList.remove('button--active');
						//button on nav
						let getFilterNav =  section.querySelector(`[data-key="${activeKey}"]`)//just in case resize
						getFilterNav.dataset.active = 1;
						getFilterNav.classList.add('button--active');

					} else {
						console.log('Error during fetch response');
					}
				})
				.catch(error => {
					console.log('Error during fetch: ' + error);
				});

		});
	}
}

/**
 * fetchCaseStudies
 * @param {Number} activeKey TermId
 * @param {Number} paged Default 1
 * @returns JSON response (Casestudies)
 */
const fetchCaseStudies = async ( activeKey, paged = 1, exclude = ''  ) => {
	// FORM
	const formData = new FormData();
	formData.set('security', wp_ajax.security);
	formData.set('activeKey', activeKey);
	formData.set('paged', paged);

	if (exclude) {
		formData.set('exclude', exclude);
	}

	const response = await fetch(`${wp_ajax.ajax_url}?action=case_study_load_more`, {
		method: 'POST',
		body: formData
	})

	if (!response.ok) {
		const message = `An error has occured: ${response.status}`;
		throw new Error(message);
	}

	const caseStudies = await response.json();

  	return caseStudies;
}
